<script>
import ReportingApi from "@/services/reporting-api";
import CustomersApi from "@/services/customers-api";
import ClaimApi from "@/services/claim-api";


import i18n from "@/i18n";

import PieChart from '@/components/PieChart.vue'
import SemiCircleGauge from '@/components/SemiCircleGauge.vue'
import BarChartPercentage from '@/components/BarChartPercentage.vue'
import HorizentalBarChart from '@/components/HorizentalBarChart.vue'
import HorizentalBarChartCount from '@/components/HorizentalBarChartCount.vue'
import DynamicGroupedBarChart from '@/components/DynamicGroupedBarChart.vue'


export default {
    components: {BarChartPercentage  , HorizentalBarChart , PieChart, SemiCircleGauge,DynamicGroupedBarChart ,HorizentalBarChartCount},
    data(){
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth(); 

        return{
            currentYear ,
            currentMonth,
            yearForLine:currentYear,
            year:currentYear,            
            month:currentMonth,
            chartOptionsMonthly: {
                chart: {
                    id: 'reclamation-percentage-line',
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    min: 0,
                    max: 100,
                    tickAmount: 5, 
                    labels: {
                        formatter: val => `${val}%`
                    }
                }

            },
            seriesMonthly: [
                {
                name: 'Pourcentage',
                data: [],
                },
            ],
            filterSelectedServiceRateMonthly:null,
            filterSelectedCustomerRateMonthly:null,
            chartKeyMonthly: 0,

            firstDay:null,
            lastDay:null,
            skipWatch: false,
          
            
            filterCustomersList:[],
            filterServicesList:[],

            //count By Status
            isLoadingDataCountByStatus:false,
            filterEndCountByStatus:null,
            filterStartCountByStatus:null,
            filterSelectedCustomerCountByStatus:null,
            filterSelectedServiceCountByStatus:null,
            labelsCountByStatus:[],
            dataCountByStatus:[],
            componentKeyCountByStatus: 0,
            //rate By Status
            isLoadingDataRateByStatus:false,
            filterEndRateByStatus:null,
            filterStartRateByStatus:null,
            filterSelectedCustomerRateByStatus:null,
            filterSelectedServiceRateByStatus:null,
            labelsRateByStatus:[],
            dataRateByStatus:[],
            componentKeyRateByStatus: 0,

            // By Service
            filterEndCountByService:null,
            filterStartCountByService:null,
            filterSelectedCustomerByService:null,
            labelsCountByService:[],
            dataCountByService:[],

            //By Type
            filterEndCountByType:null,
            filterStartCountByType:null,
            filterSelectedServiceByType:null,
            filterSelectedCustomerByType:null,
            labelsCountByType:[],
            dataCountByType:[],

            // monthly Rate 
            thisMonthClaimsRate:null,
            thisMonthClaimsRateDifference:null,
            // yearly Rate
            thisYearClaimsRate:null,
            thisYearClaimsRateDifference:null,

            //Average duration
            currentAvgMonth:currentMonth,
            currentAvgDuration:null,
            currentAvgDurationReadable: null,
            diffAvgDurationReadable: null,
            percentageDiff: null,

            // reopened
            yearForReopened:currentYear,
            filterSelectedCustomerForReopened: null,
            filterSelectedServiceForReopened: null,
            seriesDataForReopened:[],
            monthsLabelsForReopened:[],
            chartKeyForReopened: 0,


            //rate By Validity
            isLoadingDataRateByValidity:false,
            filterEndRateByValidity:null,
            filterStartRateByValidity:null,
            filterSelectedCustomerRateByValidity:null,
            filterSelectedServiceRateByValidity:null,
            labelsRateByValidity:[],
            dataRateByValidity:[],
            componentKeyRateByValidity: 0,

            //Count Closed By UserName
            filterStartCountClosedByUserName:null,
            filterEndCountClosedByUserName:null,
            filterSelectedCustomerCountClosedByUserName:null,
            filterSelectedServiceCountClosedByUserName:null,
            labelsCountClosedByUserName:[],
            dataCountClosedByUserName:[],
            disableNextPageClosedByUserName: false,
            itemsPerPageClosedByUserName: 5,
            currentPageClosedByUserName: 1,

            //Count Grouped By Officer UserName
            filterStartCountGroupedByOfficerUserName:null,
            filterEndCountGroupedByOfficerUserName:null,
            filterSelectedCustomerCountGroupedByOfficerUserName:null,
            filterSelectedServiceCountGroupedByOfficerUserName:null,
            labelsCountGroupedByOfficerUserName:[],
            dataCountGroupedByOfficerUserName:[],
            disableNextPageGroupedByOfficerUserName: false,
            itemsPerPageGroupedByOfficerUserName: 10,
            currentPageGroupedByOfficerUserName: 1,

            //rate By BL Type ( Para - Pharma )
            isLoadingDataRateByBlType:false,
            filterEndRateByBlType:null,
            filterStartRateByBlType:null,
            filterSelectedCustomerRateByBlType:null,
            filterSelectedServiceRateByBlType:null,
            labelsRateByBlType:[],
            dataRateByBlType:[],
            componentKeyRateByBlType: 0,

            //rate By BL Date Per Week Day
            isLoadingDataRateByBlDatePerWeekDay:false,
            filterStartRateByBlDatePerWeekDay:null,
            filterEndRateByBlDatePerWeekDay:null,
            filterSelectedCustomerRateByBlDatePerWeekDay:null,
            filterSelectedServiceRateByBlDatePerWeekDay:null,
            labelsRateByBlDatePerWeekDay:[],
            dataRateByBlDatePerWeekDay:[],
            componentKeyRateByBlDatePerWeekDay: 0,

            //rate By BL Date Per Hour
            isLoadingDataRateByBlDatePerHour:false,
            filterStartRateByBlDatePerHour:null,
            filterEndRateByBlDatePerHour:null,
            filterSelectedCustomerRateByBlDatePerHour:null,
            filterSelectedServiceRateByBlDatePerHour:null,
            labelsRateByBlDatePerHour:[],
            dataRateByBlDatePerHour:[],
            componentKeyRateByBlDatePerHour: 0,


            filterStartClaimIdentification: null,
            filterEndClaimIdentification: null,
            filterSelectedCustomerClaimIdentification: null,
            filterSelectedServiceClaimIdentification: null,
            isLoadingClaimIdentificationStats: false,
            componentKeyClaimIdentificationStats: 0,

            unidentifiedClaims: 0,
            unidentifiedPercentage: 0,
            identifiedClaims: 0,
            identifiedPercentage: 0
        }

    },
    mounted(){
        this.getClaimsReopened()
        this.getClaimsRateMonthly();
        this.getClaimsRateByYear();
        this.getClaimsRateByMonth();
        this.skipWatch= true
        var date = new Date();
        //set First day of the current month 
        this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const startoffset = this.firstDay.getTimezoneOffset()
        this.firstDay= new Date(this.firstDay.getTime() - (startoffset*60*1000))
        this.firstDay=this.firstDay.toISOString().split('T')[0]
        this.filterStartCountByStatus = this.firstDay
        this.filterStartRateByStatus = this.firstDay
        this.filterStartRateByBlType = this.firstDay
        this.filterStartRateByBlDatePerHour = this.firstDay
        this.filterStartRateByBlDatePerWeekDay = this.firstDay
        this.filterStartRateByValidity = this.firstDay
        this.filterStartCountByService = this.firstDay
        this.filterStartCountByType = this.firstDay
        this.filterStartCountClosedByUserName = this.firstDay
        this.filterStartCountGroupedByOfficerUserName = this.firstDay
        this.filterStartClaimIdentification = this.firstDay 

        //set Last day of the current month 
        this.lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const endoffset = this.lastDay.getTimezoneOffset()
        this.lastDay= new Date(this.lastDay.getTime() - (endoffset*60*1000))
        this.lastDay=this.lastDay.toISOString().split('T')[0]
        this.filterEndCountByStatus = this.lastDay
        this.filterEndRateByStatus = this.lastDay
        this.filterEndRateByBlType = this.lastDay
        this.filterEndRateByBlDatePerHour = this.lastDay
        this.filterEndRateByBlDatePerWeekDay = this.lastDay
        this.filterEndRateByValidity = this.lastDay
        this.filterEndCountByService = this.lastDay
        this.filterEndCountByType = this.lastDay
        this.filterEndCountClosedByUserName = this.lastDay 
        this.filterEndCountGroupedByOfficerUserName = this.lastDay 
        this.filterEndClaimIdentification = this.lastDay 

        this.$nextTick(() => {
            this.skipWatch = false;
          });

        this.getClaimsRateByStatus();
        this.getClaimsRateByBlType();
        this.getClaimsRateByBlDatePerHour();
        this.getClaimsRateByBlDatePerWeekDay();
        this.getClaimIdentificationStats();
        this.getClaimsRateByValidity();
        this.getClaimsCountByStatus();
        this.getClaimsRateDuration();
        if(this.$cookies.get('userr') && this.$cookies.get('userr')==1 ){
            this.getCustomers();
        }
        if(this.isClaimTypeEnabled){
            this.getALLClaimsServices();
            this.getClaimsRateByService();
            this.getClaimsRateByType();
            this.getClaimsCountClosedByUserName(this.currentPageClosedByUserName,this.itemsPerPageClosedByUserName);
            this.getClaimsCountGroupedByOfficerUserName(this.currentPageGroupedByOfficerUserName,this.itemsPerPageGroupedByOfficerUserName);

        }
    },
    computed:{
        isClaimTypeEnabled(){
          return  process.env.VUE_APP_FEATURE_CLAIM_TYPE === 'true'
        },
        yearOptions() {
            const startYear = 2020;
            const years = [];
            for (let y = startYear; y <= this.currentYear; y++) {
                years.push(y);
            }
            return years;
        },
        ifDefaultTheme(){
            return  process.env.VUE_APP_THEME == 0
        },
        chartColor() {
            return this.ifDefaultTheme ? '#008FFB' : '#4f81bd'; 
        },  
    },
    watch: {
        //count By Status
        filterSelectedCustomerCountByStatus: function(){
            this.getClaimsCountByStatus() 
        },
        filterSelectedServiceCountByStatus: function(){
            this.getClaimsCountByStatus()  
        },
        filterEndCountByStatus: function(){
            if(!this.skipWatch &&((this.filterEndCountByStatus && this.filterStartCountByStatus)|| (!this.filterEndCountByStatus && !this.filterStartCountByStatus)))
                this.getClaimsCountByStatus()
        },
        filterStartCountByStatus: function(){
            if(!this.skipWatch &&((this.filterEndCountByStatus && this.filterStartCountByStatus)|| (!this.filterEndCountByStatus && !this.filterStartCountByStatus)))
                this.getClaimsCountByStatus()
        },

        //rate By Status
        filterSelectedCustomerRateByStatus: function(){
            this.getClaimsRateByStatus() 
        },
        filterSelectedServiceRateByStatus: function(){
            this.getClaimsRateByStatus()  
        },
        filterEndRateByStatus: function(){
            if(!this.skipWatch &&((this.filterEndRateByStatus && this.filterStartRateByStatus)|| (!this.filterEndRateByStatus && !this.filterStartRateByStatus)))
                this.getClaimsRateByStatus()
        },
        filterStartRateByStatus: function(){
            if(!this.skipWatch &&((this.filterEndRateByStatus && this.filterStartRateByStatus)|| (!this.filterEndRateByStatus && !this.filterStartRateByStatus)))
                this.getClaimsRateByStatus()
        },

        //BY Service
        filterSelectedCustomerByService: function(){
            this.getClaimsRateByService() 
        },
              
        filterEndCountByService: function(){
            if(!this.skipWatch &&((this.filterEndCountByService && this.filterStartCountByService)|| (!this.filterEndCountByService && !this.filterStartCountByService)))
                this.getClaimsRateByService()
        },
        filterStartCountByService: function(){
            if(!this.skipWatch &&((this.filterEndCountByService && this.filterStartCountByService)|| (!this.filterEndCountByService && !this.filterStartCountByService)))
                this.getClaimsRateByService()
        },


        //By type
        filterSelectedCustomerByType: function(){
            this.getClaimsRateByType() 
        },
        filterSelectedServiceByType: function(){
            this.getClaimsRateByType()  
        },   
        filterEndCountByType: function(){
            if(!this.skipWatch &&((this.filterEndCountByType && this.filterStartCountByType)|| (!this.filterEndCountByType && !this.filterStartCountByType)))
                this.getClaimsRateByType()
        },
        filterStartCountByType: function(){
            if(!this.skipWatch &&((this.filterEndCountByType && this.filterStartCountByType)|| (!this.filterEndCountByType && !this.filterStartCountByType)))
                this.getClaimsRateByType()
        },

       
        //monthly rate
        filterSelectedCustomerRateMonthly: function(){
            this.getClaimsRateMonthly() 
        },
        filterSelectedServiceRateMonthly: function(){
            this.getClaimsRateMonthly()  
        },  
        yearForLine:function(){
            this.getClaimsRateMonthly() 
        },

        //Reopened Claims
        filterSelectedCustomerForReopened: function(){
            this.getClaimsReopened() 
        },
        filterSelectedServiceForReopened: function(){
            this.getClaimsReopened()  
        },  
        yearForReopened:function(){
            this.getClaimsReopened() 
        },


         //rate By Validity
        filterSelectedCustomerRateByValidity: function(){
            this.getClaimsRateByValidity() 
        },
        filterSelectedServiceRateByValidity: function(){
            this.getClaimsRateByValidity()  
        },
        filterEndRateByValidity: function(){
            if(!this.skipWatch &&((this.filterEndRateByValidity && this.filterStartRateByValidity)|| (!this.filterEndRateByValidity && !this.filterStartRateByValidity)))
                this.getClaimsRateByValidity()
        },
        filterStartRateByValidity: function(){
            if(!this.skipWatch &&((this.filterEndRateByValidity && this.filterStartRateByValidity)|| (!this.filterEndRateByValidity && !this.filterStartRateByValidity)))
                this.getClaimsRateByValidity()
        },

        //Count Closed By UserName
        filterSelectedCustomerCountClosedByUserName: function(){
            this.getClaimsCountClosedByUserName(this.currentPageClosedByUserName,this.itemsPerPageClosedByUserName)
        },
        filterSelectedServiceCountClosedByUserName: function(){
            this.getClaimsCountClosedByUserName(this.currentPageClosedByUserName,this.itemsPerPageClosedByUserName)
        },
        filterEndCountClosedByUserName: function(){
            if(!this.skipWatch &&((this.filterEndCountClosedByUserName && this.filterStartCountClosedByUserName)|| (!this.filterEndCountClosedByUserName && !this.filterStartCountClosedByUserName)))
                this.getClaimsCountClosedByUserName(this.currentPageClosedByUserName,this.itemsPerPageClosedByUserName)
        },
        filterStartCountClosedByUserName: function(){
            if(!this.skipWatch &&((this.filterEndCountClosedByUserName && this.filterStartCountClosedByUserName)|| (!this.filterEndCountClosedByUserName && !this.filterStartCountClosedByUserName)))
                this.getClaimsCountClosedByUserName(this.currentPageClosedByUserName,this.itemsPerPageClosedByUserName)
        },


        // Count Grouped By Officer UserName
        filterSelectedCustomerCountGroupedByOfficerUserName: function(){
            this.getClaimsCountGroupedByOfficerUserName(this.currentPageGroupedByOfficerUserName,this.itemsPerPageGroupedByOfficerUserName);
        },
        filterSelectedServiceCountGroupedByOfficerUserName: function(){
            this.getClaimsCountGroupedByOfficerUserName(this.currentPageGroupedByOfficerUserName,this.itemsPerPageGroupedByOfficerUserName);
        },
        filterEndCountGroupedByOfficerUserName: function(){
            if(!this.skipWatch &&((this.filterEndCountGroupedByOfficerUserName && this.filterStartCountGroupedByOfficerUserName)|| (!this.filterEndCountGroupedByOfficerUserName && !this.filterStartCountGroupedByOfficerUserName)))
            this.getClaimsCountGroupedByOfficerUserName(this.currentPageGroupedByOfficerUserName,this.itemsPerPageGroupedByOfficerUserName);
        },
        filterStartCountGroupedByOfficerUserName: function(){
            if(!this.skipWatch &&((this.filterEndCountGroupedByOfficerUserName && this.filterStartCountGroupedByOfficerUserName)|| (!this.filterEndCountGroupedByOfficerUserName && !this.filterStartCountGroupedByOfficerUserName)))
            this.getClaimsCountGroupedByOfficerUserName(this.currentPageGroupedByOfficerUserName,this.itemsPerPageGroupedByOfficerUserName);
        },

         //rate By BL Type
        filterSelectedCustomerRateByBlType: function(){
            this.getClaimsRateByBlType() 
        },
        filterSelectedServiceRateByBlType: function(){
            this.getClaimsRateByBlType()  
        },
        filterEndRateByBlType: function(){
            if(!this.skipWatch &&((this.filterEndRateByBlType && this.filterStartRateByBlType)|| (!this.filterEndRateByBlType && !this.filterStartRateByBlType)))
                this.getClaimsRateByBlType()
        },
        filterStartRateByBlType: function(){
            if(!this.skipWatch &&((this.filterEndRateByBlType && this.filterStartRateByBlType)|| (!this.filterEndRateByBlType && !this.filterStartRateByBlType)))
                this.getClaimsRateByBlType()
        },
        
         //rate stat
        filterSelectedServiceClaimIdentification: function(){
            this.getClaimIdentificationStats() 
        },
        filterSelectedCustomerClaimIdentification: function(){
            this.getClaimIdentificationStats()  
        },
        filterStartClaimIdentification: function(){
            if(!this.skipWatch &&((this.filterEndClaimIdentification && this.filterStartClaimIdentification)|| (!this.filterEndClaimIdentification && !this.filterStartClaimIdentification)))
                this.getClaimIdentificationStats()
        },
        filterEndClaimIdentification: function(){
            if(!this.skipWatch &&((this.filterEndClaimIdentification && this.filterStartClaimIdentification)|| (!this.filterEndClaimIdentification && !this.filterStartClaimIdentification)))
                this.getClaimIdentificationStats()
        },




        //rate By BL date Per Week Day 
        filterSelectedCustomerRateByBlDatePerWeekDay: function(){
            this.getClaimsRateByBlDatePerWeekDay() 
        },
        filterSelectedServiceRateByBlDatePerWeekDay: function(){
            this.getClaimsRateByBlDatePerWeekDay()  
        },
        filterEndRateByBlDatePerWeekDay: function(){
            if(!this.skipWatch &&((this.filterEndRateByBlDatePerWeekDay && this.filterStartRateByBlDatePerWeekDay)|| (!this.filterEndRateByBlDatePerWeekDay && !this.filterStartRateByBlDatePerWeekDay)))
                this.getClaimsRateByBlDatePerWeekDay()
        },
        filterStartRateByBlDatePerWeekDay: function(){
            if(!this.skipWatch &&((this.filterEndRateByBlDatePerWeekDay && this.filterStartRateByBlDatePerWeekDay)|| (!this.filterEndRateByBlDatePerWeekDay && !this.filterStartRateByBlDatePerWeekDay)))
                this.getClaimsRateByBlDatePerWeekDay()
        },

        //rate By BL date Per Hour 
        filterSelectedCustomerRateByBlDatePerHour: function(){
            this.getClaimsRateByBlDatePerHour() 
        },
        filterSelectedServiceRateByBlDatePerHour: function(){
            this.getClaimsRateByBlDatePerHour()  
        },
        filterEndRateByBlDatePerHour: function(){
            if(!this.skipWatch &&((this.filterEndRateByBlDatePerHour && this.filterStartRateByBlDatePerHour)|| (!this.filterEndRateByBlDatePerHour && !this.filterStartRateByBlDatePerHour)))
                this.getClaimsRateByBlDatePerHour()
        },
        filterStartRateByBlDatePerHour: function(){
            if(!this.skipWatch &&((this.filterEndRateByBlDatePerHour && this.filterStartRateByBlDatePerHour)|| (!this.filterEndRateByBlDatePerHour && !this.filterStartRateByBlDatePerHour)))
                this.getClaimsRateByBlDatePerHour()
        },
       



    },
    methods:{
        getClaimsRateByValidity(){
             this.isLoadingDataRateByValidity = true;
            if(!this.isClaimTypeEnabled){
                this.filterSelectedServiceRateByValidity = null ;
            }
            ReportingApi.getClaimsRateByValidity(this.filterStartRateByValidity, this.filterEndRateByValidity, 
                        this.filterSelectedCustomerRateByValidity == null ? null : this.filterSelectedCustomerRateByValidity.id ,
                        this.filterSelectedServiceRateByValidity == null ? null : this.filterSelectedServiceRateByValidity.value,
                    true)
            .then(
                result => {
                    if(result && result.values && result.labels){

                        this.componentKeyRateByValidity += 1;
                        this.labelsRateByValidity = result.labels
                        this.dataRateByValidity = result.values
                    }else{
                        this.labelsRateByValidity=[]
                        this.dataRateByValidity=[]
                    }
                    

                
            })
            .finally(()=>{
                this.isLoadingDataRateByValidity = false;
            })
            
        },
        getClaimsReopened(){
            ReportingApi.getClaimsReopened(this.yearForReopened,
            this.filterSelectedCustomerForReopened == null ? null : this.filterSelectedCustomerForReopened.id , 
            this.filterSelectedServiceForReopened ==null ? null : this.filterSelectedServiceForReopened.value) 
            .then((result) => {

                this.monthsLabelsForReopened = result.labels
                this.seriesDataForReopened=[
                        { name: "Nombre de réclamations", data: result.values },
                        { name: "Nombre de réclamations réouvertes", data: result.reopenedValues }
                    ]
                this.chartKeyForReopened ++ ;
            });

        },
       
        getClaimsRateMonthly(){
        
            ReportingApi.getClaimsRateMonthly(this.yearForLine,
            this.filterSelectedCustomerRateMonthly == null ? null : this.filterSelectedCustomerRateMonthly.id , 
            this.filterSelectedServiceRateMonthly ==null ? null : this.filterSelectedServiceRateMonthly.value)
            .then((result) => {

                let months = result.labels;
                let percentages = result.values;

               

               
                this.seriesMonthly = [
                    {
                        name: 'Pourcentage',
                        data: percentages
                    }
                ];

                this.chartOptionsMonthly = {
                    ...this.chartOptionsMonthly,
                    colors: [this.chartColor],
                    xaxis: {
                        ...this.chartOptionsMonthly.xaxis,
                        categories: months
                    },
                    yaxis: {
                        min: 0,
                        max: 100,
                        tickAmount: 5, 
                        labels: {
                            formatter: val => `${val}%`
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: val => `${val}%`
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: val => `${val}%`
                    }

                };

                this.chartKeyMonthly++;
            });
        },
        getClaimsRateByMonth(){
            ReportingApi.getClaimsRate(this.currentYear ,this.month,false) 
                .then(result => {
                    this.thisMonthClaimsRate=result.current;
                    this.thisMonthClaimsRateDifference=result.difference;
                });
        },
        getClaimsRateByYear(){

            ReportingApi.getClaimsRate(this.year,null,true) 
                .then(result => {
                    this.thisYearClaimsRate=result.current
                    this.thisYearClaimsRateDifference=result.difference;
                });
        },
        getClaimsCountByStatus() {
            this.isLoadingDataCountByStatus = true;
            if(!this.isClaimTypeEnabled){
                this.filterSelectedServiceCountByStatus = null ;
            }
            ReportingApi.getClaimsRateByStatus(this.filterStartCountByStatus, this.filterEndCountByStatus, 
                        this.filterSelectedCustomerCountByStatus == null ? null : this.filterSelectedCustomerCountByStatus.id ,
                        this.filterSelectedServiceCountByStatus == null ? null : this.filterSelectedServiceCountByStatus.value,
                    false)
            .then(
                result => {
                    if(result && result.values && result.labels){

                        this.componentKeyCountByStatus += 1;
                        this.labelsCountByStatus = result.labels
                        this.dataCountByStatus = result.values
                    }else{
                        this.labelsCountByStatus=[]
                        this.dataCountByStatus=[]
                    }
                    

                
            })
            .finally(()=>{
                this.isLoadingDataCountByStatus = false;
            })
            
        },
        getClaimsRateByStatus() {
            this.isLoadingDataRateByStatus = true;
            if(!this.isClaimTypeEnabled){
                this.filterSelectedServiceRateByStatus = null ;
            }
            ReportingApi.getClaimsRateByStatus(this.filterStartRateByStatus, this.filterEndRateByStatus, 
                        this.filterSelectedCustomerRateByStatus == null ? null : this.filterSelectedCustomerRateByStatus.id ,
                        this.filterSelectedServiceRateByStatus == null ? null : this.filterSelectedServiceRateByStatus.value,
                    true)
            .then(
                result => {
                    if(result && result.values && result.labels){

                        this.componentKeyRateByStatus += 1;
                        this.labelsRateByStatus = result.labels
                        this.dataRateByStatus = result.values
                    }else{
                        this.labelsRateByStatus=[]
                        this.dataRateByStatus=[]
                    }
                    

                
            })
            .finally(()=>{
                this.isLoadingDataRateByStatus = false;
            })
            
        },

        getClaimIdentificationStats() {
            if (this.filterStartClaimIdentification == null || this.filterEndClaimIdentification == null) {
                return;
            }

            this.isLoadingClaimIdentificationStats = true;

            if (!this.isClaimTypeEnabled) {
                this.filterSelectedServiceClaimIdentification = null;
            }

            ReportingApi.getClaimIdentificationStats(
                this.filterStartClaimIdentification,
                this.filterEndClaimIdentification,
                this.filterSelectedCustomerClaimIdentification == null
                    ? null
                    : this.filterSelectedCustomerClaimIdentification.id,
                this.filterSelectedServiceClaimIdentification == null
                    ? null
                    : this.filterSelectedServiceClaimIdentification.value,
                true
            )
                .then(result => {
                    if (result) {
                        this.componentKeyClaimIdentificationStats++;
                        this.unidentifiedClaims = result.unidentifiedClaims;
                        this.unidentifiedPercentage = result.unidentifiedPercentage;
                        this.identifiedClaims = result.identifiedClaims;
                        this.identifiedPercentage = result.identifiedPercentage;
                    } else {
                        this.unidentifiedClaims = 0;
                        this.unidentifiedPercentage = 0;
                        this.identifiedClaims = 0;
                        this.identifiedPercentage = 0;
                    }
                })
                .finally(() => {
                    this.isLoadingClaimIdentificationStats = false;
                });
        },

        getClaimsRateByBlDatePerWeekDay() {
            if(this.filterStartRateByBlDatePerWeekDay==null || this.filterEndRateByBlDatePerWeekDay == null){
                return;
            }
            this.isLoadingDataRateByBlDatePerWeekDay = true;
            if(!this.isClaimTypeEnabled){
                this.filterSelectedServiceRateByBlDatePerWeekDay = null ;
            }
            ReportingApi.getClaimsRateByBlDatePerWeekDay(this.filterStartRateByBlDatePerWeekDay, this.filterEndRateByBlDatePerWeekDay, 
                        this.filterSelectedCustomerRateByBlDatePerWeekDay == null ? null : this.filterSelectedCustomerRateByBlDatePerWeekDay.id ,
                        this.filterSelectedServiceRateByBlDatePerWeekDay == null ? null : this.filterSelectedServiceRateByBlDatePerWeekDay.value,
                    true)
            .then(
                result => {
                    if(result && result.values && result.labels){

                        this.componentKeyRateByBlDatePerWeekDay += 1;
                        this.labelsRateByBlDatePerWeekDay = result.labels
                        this.dataRateByBlDatePerWeekDay = result.values
                    }else{
                        this.labelsRateByBlDatePerWeekDay=[]
                        this.dataRateByBlDatePerWeekDay=[]
                    }
            })
            .finally(()=>{
                this.isLoadingDataRateByBlDatePerWeekDay = false;
            })
            
        },
        getClaimsRateByBlDatePerHour() {
            if(this.filterStartRateByBlDatePerHour==null || this.filterEndRateByBlDatePerHour == null){
                return;
            }
            this.isLoadingDataRateByBlDatePerHour = true;
            if(!this.isClaimTypeEnabled){
                this.filterSelectedServiceRateByBlDatePerHour = null ;
            }
            ReportingApi.getClaimsRateByBlDatePerHour(this.filterStartRateByBlDatePerHour, this.filterEndRateByBlDatePerHour, 
                        this.filterSelectedCustomerRateByBlDatePerHour == null ? null : this.filterSelectedCustomerRateByBlDatePerHour.id ,
                        this.filterSelectedServiceRateByBlDatePerHour == null ? null : this.filterSelectedServiceRateByBlDatePerHour.value,
                    true)
            .then(
                result => {
                    if(result && result.values && result.labels){

                        this.componentKeyRateByBlDatePerHour += 1;
                        this.labelsRateByBlDatePerHour = result.labels
                        this.dataRateByBlDatePerHour = result.values
                    }else{
                        this.labelsRateByBlDatePerHour=[]
                        this.dataRateByBlDatePerHour=[]
                    }
            })
            .finally(()=>{
                this.isLoadingDataRateByBlDatePerHour = false;
            })
            
        },
        getClaimsRateByBlType(){
             this.isLoadingDataRateByBlType = true;
            if(!this.isClaimTypeEnabled){
                this.filterSelectedServiceRateByBlType = null ;
            }
            ReportingApi.getClaimsRateByBlType(this.filterStartRateByBlType, this.filterEndRateByBlType, 
                        this.filterSelectedCustomerRateByBlType == null ? null : this.filterSelectedCustomerRateByBlType.id ,
                        this.filterSelectedServiceRateByBlType == null ? null : this.filterSelectedServiceRateByBlType.value)
            .then(
                result => {
                    if(result && result.values && result.labels){

                        this.componentKeyRateByBlType += 1;
                        this.labelsRateByBlType = result.labels
                        this.dataRateByBlType = result.values
                    }else{
                        this.labelsRateByBlType=[]
                        this.dataRateByBlType=[]
                        this.componentKeyRateByBlType += 1;
                    }
            })
            .finally(()=>{
                this.isLoadingDataRateByBlType = false;
            })
        },
        getClaimsRateDuration() {
            ReportingApi.getClaimsRateDuration(this.currentAvgMonth)
            .then(
                result => {
                    this.currentAvgDuration=result.currentAvg
                    this.percentageDiff=result.percentageDiff
                    this.currentAvgDurationReadable=result.currentReadable
                    this.diffAvgDurationReadable=result.diffReadable

            })  
        },
        getClaimsRateByService() {
            if(!this.isClaimTypeEnabled){
                return;
            }
            
            ReportingApi.getClaimsRateByService(this.filterStartCountByService, this.filterEndCountByService, 
                        this.filterSelectedCustomerByService == null ? null : this.filterSelectedCustomerByService.id)
            .then(
                result => {
               
                this.labelsCountByService=[]
                this.dataCountByService=[]
                this.labelsCountByService=result.labels
                this.dataCountByService=result.values
            })
    
        },

        getClaimsRateByType() {
            if(!this.isClaimTypeEnabled){
                return;
            }
            ReportingApi.getClaimsRateByType(this.filterStartCountByType, this.filterEndCountByType, 
                this.filterSelectedCustomerByType == null ? null : this.filterSelectedCustomerByType.id,
                this.filterSelectedServiceByType == null ? null :  this.filterSelectedServiceByType.value)
            .then(
                result => {

                    this.labelsCountByType=[]
                    this.dataCountByType=[]
                    this.labelsCountByType=result.labels
                    this.dataCountByType=result.values
            })
    
        },
        getClaimsCountClosedByUserName(pageNumber,pageSize) {
            if(!this.isClaimTypeEnabled){
                return;
            }
           
            ReportingApi.getClaimsCountClosedByUserName(this.filterStartCountClosedByUserName, this.filterEndCountClosedByUserName, 
                this.filterSelectedCustomerCountClosedByUserName == null ? null : this.filterSelectedCustomerCountClosedByUserName.id,
                this.filterSelectedServiceCountClosedByUserName == null ? null :  this.filterSelectedServiceCountClosedByUserName.value,
                pageNumber,pageSize)
            .then(
                result => {

                    
                    this.disableNextPageClosedByUserName=false
                    if(result && result.labels?.length != 0){
                        
                        this.labelsCountClosedByUserName=result.labels
                        this.dataCountClosedByUserName=result.counts
                        this.currentPageClosedByUserName = pageNumber
                        this.itemsPerPageClosedByUserName= pageSize
                    }else{
                        this.disableNextPageClosedByUserName=true
                    }
               
            })
    
        },

        getClaimsCountGroupedByOfficerUserName(pageNumber,pageSize) {
            if(!this.isClaimTypeEnabled){
                return;
            }
           
            ReportingApi.getClaimsCountGroupedByOfficerUserName(this.filterStartCountGroupedByOfficerUserName, this.filterEndCountGroupedByOfficerUserName, 
                this.filterSelectedCustomerCountGroupedByOfficerUserName == null ? null : this.filterSelectedCustomerCountGroupedByOfficerUserName.id,
                this.filterSelectedServiceCountGroupedByOfficerUserName == null ? null :  this.filterSelectedServiceCountGroupedByOfficerUserName.value,
                pageNumber,pageSize)
            .then( result => {

                    this.disableNextPageGroupedByOfficerUserName=false
                    if(result && result.labels?.length != 0){
                        this.labelsCountGroupedByOfficerUserName=result.labels
                        this.dataCountGroupedByOfficerUserName=result.counts
                        this.currentPageGroupedByOfficerUserName = pageNumber
                        this.itemsPerPageGroupedByOfficerUserName= pageSize
                    }else{
                        this.disableNextPageGroupedByOfficerUserName=true
                        if(pageNumber==1){
                            this.labelsCountGroupedByOfficerUserName=[]
                            this.dataCountGroupedByOfficerUserName=[]
                        }
                    }
            })
    
        },

        getCustomers(){
            CustomersApi.getCustomers(null,null).then(
                response => {
                this.filterCustomersList=response;
                }
            )
        },
        getALLClaimsServices(){
            ClaimApi.getServicesCount().then(
                result => {
                    if(result){
                        ClaimApi.getClaimsServices(null,result,null,false).then(
                            response => {    
                            this.filterServicesList = response.list;
                        })
                    }
                }
            )
        },
        statusToLabel(status) {
          switch(status) {
            case 0: return i18n.t('reporting.supplier.tabClaimsState.claimStatus.statusLabel.new');
            case 1: return i18n.t('reporting.supplier.tabClaimsState.claimStatus.statusLabel.inProgress');
            case 2: return i18n.t('reporting.supplier.tabClaimsState.claimStatus.statusLabel.closed');
            default: return '';
          }
        },
        statusToColor(status) {
          switch(status) {
            case 0: return '#f46a6a';
            case 1: return '#f1b44c';
            case 2: return '#34c38f'
            case 4: return '#74788d';
            default: return 'secondary';
          }
        },
        isRowEmpty(row) {
        return row.every(cell => !cell);
        },
    },
  

}
</script>
<template>
    <div class="m-0 p-0 ">
    <div class="row ">

 
<div class="col-12 flex-wrap  d-md-flex align-items-stretch ">
    
    <div class="col-md-4 col-12 pt-md-4 pl-0 pr-md-4 d-md-flex" >
        <div class="card small-card p-3 text-center w-100" >
            
            <div class="row">
                <div class="col-8 col-md-12 col-lg-8 text-left">
                    <h5 class="text-dark text-uppercase mb-1">{{$t("reporting.supplier.tabClaimsState.title1")}}</h5>
                    <span class="text-dark m-0 p-0">{{$t("reporting.supplier.tabClaimsState.subTitle1")}}</span>
                </div>
                <div class="col-4 col-md-12 col-lg-4 text-right">
                    <div class="media">
                    <div class="media-body">
                            <div class="clearfix mr-3 mt-2">
                                <div class="float-right ">
                                    <div class="input-group input-group-sm">
                                        <select class="custom-select custom-select-sm" v-model="year" @change="getClaimsRateByYear()">
                                        <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
                                        </select>
                                        <div class="input-group-append">
                                            <label class="input-group-text">{{$t('years.label')}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-12 m-2" v-if="this.thisYearClaimsRate !== null">
                    <SemiCircleGauge  :value="thisYearClaimsRate == null ? 0 :thisYearClaimsRate " />
                    <span class="text-dark">{{$t("reporting.supplier.tabClaimsState.subTitle2")}}</span>
                </div>
                <div v-if="thisYearClaimsRateDifference != null" class="col-12">
                    <p class=" text-muted font-size-14">
                        <span :class="thisYearClaimsRateDifference>0 ?'text-danger mr-2' : 'text-success mr-2'">
                        {{thisYearClaimsRateDifference}}
                        <i :class="thisYearClaimsRateDifference>0 ?'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></i>
                        </span> <span class="text-dark">{{$t("years.previous")}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
    
   

    <div class="col-md-4 col-12  pt-4  pr-md-4 d-md-flex" >
        <div class="card small-card p-3 text-center w-100" >
            <div class="row">
                <div class="col-8 col-md-12 col-lg-8 text-left">
                    <h5 class="text-dark text-uppercase mb-1">{{$t("reporting.supplier.tabClaimsState.title2")}}<span style="font-size :14px ;">({{ this.currentYear }})</span> </h5>
                    <span class="text-dark mb-1">{{$t("reporting.supplier.tabClaimsState.subTitle1")}}</span>
                </div>
                <div class="col-4 col-md-12 col-lg-4 text-right">
                    <div class="media">
                        <div class="media-body">
                            <div class="clearfix mr-3 mt-2">
                                <div class="float-right ">
                                    <div class="input-group input-group-sm">
                                        <select class="custom-select custom-select-sm"  v-model="month"  @change="getClaimsRateByMonth()">
                                        <option v-if="currentMonth>=0" selected value="0">{{$t('months.0')}}</option>
                                        <option v-if="currentMonth>=1" value="1">{{$t('months.1')}}</option>
                                        <option v-if="currentMonth>=2" value="2">{{$t('months.2')}}</option>
                                        <option v-if="currentMonth>=3" value="3">{{$t('months.3')}}</option>
                                        <option v-if="currentMonth>=4" value="4">{{$t('months.4')}}</option>
                                        <option v-if="currentMonth>=5" value="5">{{$t('months.5')}}</option>
                                        <option v-if="currentMonth>=6" value="6">{{$t('months.6')}}</option>
                                        <option v-if="currentMonth>=7" value="7">{{$t('months.7')}}</option>
                                        <option v-if="currentMonth>=8" value="8">{{$t('months.8')}}</option>
                                        <option v-if="currentMonth>=9" value="9">{{$t('months.9')}}</option>
                                        <option v-if="currentMonth>=10" value="10">{{$t('months.10')}}</option>
                                        <option v-if="currentMonth>=11" value="11">{{$t('months.11')}}</option>
                                        </select>
                                        <div class="input-group-append">
                                        <label class="input-group-text">{{$t('months.label')}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-center">
                <div class=" col-12 m-2" v-if="this.thisMonthClaimsRate !== null">
                    <SemiCircleGauge :value="thisMonthClaimsRate == null ? 0 :thisMonthClaimsRate " />
                    <span class="text-dark" style="padding-top: 10px;">{{$t("reporting.supplier.tabClaimsState.subTitle2")}}</span>
                </div>
                <p :class="thisMonthClaimsRateDifference == null ? 'invisible' :'' " class=" col-12 text-muted font-size-14" >
                    <span  :class="thisMonthClaimsRateDifference>0 ?'text-danger mr-2' : 'text-success mr-2'">
                    {{thisMonthClaimsRateDifference}}
                    <i :class="thisMonthClaimsRateDifference>0 ?'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></i>
                    </span><span class="text-dark">{{$t("months.previous")}}</span>
                </p>
            </div>        
        </div>
    </div>


    <div class="col-md-4 col-12  pt-4   d-md-flex" >
        <div class="card small-card p-3 text-center w-100" >
            <div class="row">
                <div class="col-8 col-md-12 col-lg-8 text-left">
                    <h5 class="text-dark text-uppercase mb-1">{{$t("reporting.supplier.tabClaimsState.title3")}}<span style="font-size :14px ;">({{ this.currentYear }})</span> </h5>
                    <span class="text-dark ">{{$t("reporting.supplier.tabClaimsState.subTitle3")}}</span>
                </div>
                <div class="col-4 col-md-12 col-lg-4 text-right">
                    <div class="media">
                        <div class="media-body">
                            <div class="clearfix mr-3 mt-2">
                                <div class="float-right ">
                                    <div class="input-group input-group-sm">
                                        <select class="custom-select custom-select-sm"  v-model="currentAvgMonth"  @change="getClaimsRateDuration()">
                                        <option v-if="currentMonth>=0" selected value="0">{{$t('months.0')}}</option>
                                        <option v-if="currentMonth>=1" value="1">{{$t('months.1')}}</option>
                                        <option v-if="currentMonth>=2" value="2">{{$t('months.2')}}</option>
                                        <option v-if="currentMonth>=3" value="3">{{$t('months.3')}}</option>
                                        <option v-if="currentMonth>=4" value="4">{{$t('months.4')}}</option>
                                        <option v-if="currentMonth>=5" value="5">{{$t('months.5')}}</option>
                                        <option v-if="currentMonth>=6" value="6">{{$t('months.6')}}</option>
                                        <option v-if="currentMonth>=7" value="7">{{$t('months.7')}}</option>
                                        <option v-if="currentMonth>=8" value="8">{{$t('months.8')}}</option>
                                        <option v-if="currentMonth>=9" value="9">{{$t('months.9')}}</option>
                                        <option v-if="currentMonth>=10" value="10">{{$t('months.10')}}</option>
                                        <option v-if="currentMonth>=11" value="11">{{$t('months.11')}}</option>
                                        </select>
                                        <div class="input-group-append">
                                        <label class="input-group-text">{{$t('months.label')}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-center d-flex mt-4 m-2">
                <p  v-if="this.currentAvgDuration !== null" :class="percentageDiff !=null && percentageDiff>0 ?'text-danger mr-2' : 'text-success mr-2'"  class=" col-12 pt-2 mt-5 font-size-22">{{ currentAvgDurationReadable }}</p>
                <div v-if="percentageDiff !=null" class="text-dark col-12  font-size-14" >
                    <i class="mr-1" :class="percentageDiff>0 ?'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></i>
                    <span  :class="percentageDiff>0 ?'text-danger ' : 'text-success '">{{diffAvgDurationReadable}}</span>
                    <span>{{ percentageDiff>0  ?  ' de plus ' : ' de moins'  }}</span>
                    <p> par rapport {{$t("months.previous")}}</p> 
                </div>
            </div>        
        </div>
    </div>
   
    
</div>
<div class="col-12  pt-4 d-md-flex align-items-stretch">
    <div class="col-md-6  pr-md-4 col-12 d-md-flex">
        <div class="card w-100 "> 
            <div class="card-body ">
                <div class="row">
                    <div class="col-12">
                        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark"> 
                            {{$t("reporting.supplier.tabClaimsState.cardTitle9")}}
                        </h4>
                    </div>
                </div>
                <div class="row mt-4">
                    <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                        <label>
                            <span style="color : black">Client</span>
                        </label>
                        <div class="col-12" >
                            <div class=" text-right">
                                <b-form-group  label-for="">
                                <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" 
                                :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" 
                                label="fullCompanyName"  v-model="filterSelectedCustomerCountGroupedByOfficerUserName">
                                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                                </b-form-group>
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                        <label>
                            <span style="color : black">{{$t('lists.service.filter')}}</span>
                        </label>
                        <v-select class="style-vselect-big" style="font-size:1.2em;" 
                        :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                        :placeholder="$t('lists.service.label')" label="name" :searchable="false"
                        v-model="filterSelectedServiceCountGroupedByOfficerUserName">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                        </v-select>
                    </b-form-group>
                </div>
                <div  class="row mt-2">
                    <div class="col-12 col-lg-6 pr-lg-2 ">
                        <b-form-group   label-for="">
                            <label>
                                <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}}  <strong> BL</strong></span>
                            </label>
                            <b-form-datepicker
                            v-model="filterStartCountGroupedByOfficerUserName"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright
                            hide-header
                            ></b-form-datepicker>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-lg-6   pr-lg-2">
                        <b-form-group   label-for="">
                            <label>
                                <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}}  <strong> BL</strong></span>
                            </label>
                            <b-form-datepicker
                            v-model="filterEndCountGroupedByOfficerUserName"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright                         
                            hide-header
                            ></b-form-datepicker>
                        </b-form-group>
                    </div>
                </div>

                <HorizentalBarChartCount
                    :labels.sync="labelsCountGroupedByOfficerUserName"
                    :values="dataCountGroupedByOfficerUserName"
                    :disableNext="disableNextPageGroupedByOfficerUserName"
                    :currentPage="currentPageGroupedByOfficerUserName"
                    :itemsPerPage="itemsPerPageGroupedByOfficerUserName"
                    :isLocked="false"
                    :color="chartColor"
                    :use-colors="false"
                    @page-changed="getClaimsCountGroupedByOfficerUserName"

                />

            </div>
        </div> 
    </div>
    <div class="col-md-6 col-12  pt-4 pt-md-0  d-md-flex">
      <div class="card w-100 "> 
            <div class="card-body ">
                <div class="row">
                    <div class="col-12">
                        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark"> 
                            {{$t("reporting.supplier.tabClaimsState.cardTitle8")}}
                        </h4>
                    </div>
                </div>
                <div class="row mt-4">
                    <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                        <label>
                            <span style="color : black">Client</span>
                        </label>
                        <div class="col-12" >
                            <div class=" text-right">
                                <b-form-group label-for="">
                                <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" 
                                :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" 
                                label="fullCompanyName"  v-model="filterSelectedCustomerCountClosedByUserName">
                                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                                </b-form-group>
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                        <label>
                            <span style="color : black">{{$t('lists.service.filter')}}</span>
                        </label>
                        <v-select class="style-vselect-big" style="font-size:1.2em;" 
                        :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                        :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceCountClosedByUserName" :searchable="false">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                        </v-select>
                    </b-form-group>
                </div>
                <div  class="row mt-2">
                    <div class="col-12 col-lg-6 pr-lg-2 ">
                        <b-form-group   label-for="">
                            <label>
                                <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong> Réclamation </strong></span>
                            </label>
                            <b-form-datepicker
                            v-model="filterStartCountClosedByUserName"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright
                            hide-header
                            ></b-form-datepicker>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-lg-6   pr-lg-2">
                        <b-form-group   label-for="">
                            <label>
                                <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}} <strong> Réclamation </strong></span>
                            </label>
                            <b-form-datepicker
                            v-model="filterEndCountClosedByUserName"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright                         
                            hide-header
                            ></b-form-datepicker>
                        </b-form-group>
                    </div>
                </div>
                <p v-if="isRowEmpty(this.dataCountClosedByUserName) == true">Pas de données à afficher.</p> 

                <HorizentalBarChartCount
                    :labels.sync="labelsCountClosedByUserName"
                    :values="dataCountClosedByUserName"
                    :disableNext="disableNextPageClosedByUserName"
                    :currentPage="currentPageClosedByUserName"
                    :itemsPerPage="itemsPerPageClosedByUserName"
                    title=""
                    :color="chartColor"
                    :use-colors="false"
                    :isLocked="false"
                    @page-changed="getClaimsCountClosedByUserName"
                />
            </div>
        </div> 
    </div>
</div>
<div class="col-12  pt-4 d-md-flex align-items-stretch">

    <div class="col-md-6 col-12 pr-md-4 d-md-flex">

    <div class="card w-100 "> 
        <div class="card-body ">
            <div class="row">
                <div class="col-12">
                    <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark"> {{$t("reporting.supplier.tabClaimsState.cardTitle1")}} </h4>
                </div> 
            </div>
            <div class="row mt-4">
                <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                    <label>
                        <span style="color : black">Client</span>
                    </label>
                    <div class="col-12" >
                        <div class=" text-right">
                            <b-form-group label-for="">
                            <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="filterSelectedCustomerCountByStatus">
                                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                            </v-select>
                            </b-form-group>
                        </div>
                    </div>
                </b-form-group>

            
                


                <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                    <label>
                        <span style="color : black">{{$t('lists.service.filter')}}</span>
                    </label>
                    <v-select class="style-vselect-big" style="font-size:1.2em;" 
                    :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                    :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceCountByStatus" :searchable="false">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                    </v-select>
                </b-form-group>
            </div>
            <div  class="row mt-2">
                <div class="col-12 col-lg-6 pr-lg-2 ">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong> Réclamation</strong></span>
                    </label>
                    <b-form-datepicker
                    v-model="filterStartCountByStatus"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
                <div class="col-12 col-lg-6   pr-lg-2">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}} <strong> Réclamation</strong></span>
                    </label>
                    <b-form-datepicker
                    v-model="filterEndCountByStatus"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright                         
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
            </div>
            <p v-if="isRowEmpty(this.dataCountByStatus) == true">Pas de données à afficher.</p>
            <BarChartPercentage class=" mt-4 pr-md-2" :height="350" :labels.sync="this.labelsCountByStatus" :data.sync="this.dataCountByStatus"  :key="componentKeyCountByStatus" :requestedPercentages="false"  />
        </div>
    </div> 
    </div>
    <div class="col-md-6 col-12  pt-4 pt-md-0 d-md-flex">

    <div class="card w-100 ">
        <div class="card-body ">
            <div class="row">
                <div class="col-12">
                    <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark"> {{$t("reporting.supplier.tabClaimsState.cardTitle2")}} </h4>
                </div>
            </div> 
            <div class="row mt-4">
                <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                    <label>
                        <span style="color : black">Client</span>
                    </label>
                    <div class="col-12" >
                        <div class=" text-right">
                            <b-form-group label-for="">
                            <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="filterSelectedCustomerRateByStatus">
                                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                            </v-select>
                            </b-form-group>
                        </div>
                    </div>
                </b-form-group>

            
                


                <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                    <label>
                        <span style="color : black">{{$t('lists.service.filter')}}</span>
                    </label>
                    <v-select class="style-vselect-big" style="font-size:1.2em;" 
                    :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                    :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceRateByStatus" :searchable="false">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                    </v-select>
                </b-form-group>
            </div>
            <div  class="row mt-2">
                <div class="col-12 col-lg-6 pr-lg-2 ">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong> Réclamation</strong></span>
                    </label>
                    <b-form-datepicker
                    v-model="filterStartRateByStatus"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
                <div class="col-12 col-lg-6   pr-lg-2">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}} <strong> Réclamation</strong></span>
                    </label>
                    <b-form-datepicker
                    v-model="filterEndRateByStatus"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright                         
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
            </div>
            <p v-if="isRowEmpty(this.dataRateByStatus) == true">Pas de données à afficher.</p>
            <PieChart class=" mt-4 pr-md-2" 
            :height="350" :labels.sync="this.labelsRateByStatus" 
            :series.sync="this.dataRateByStatus"  :key="componentKeyRateByStatus"   />
        </div>
    </div>
    </div>
</div>


<div v-if="isClaimTypeEnabled" class="col-12  pt-4 d-md-flex align-items-stretch" style="min-height: 779px;">


<div class="col-md-6 col-12 pr-md-4 d-md-flex">

        <div class="card w-100 "> 
            <div class="card-body ">

        <div class="row">
            <div class="col-12">
                <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark">
                    {{$t("reporting.supplier.tabClaimsState.cardTitle3")}}
                </h4>
            </div>
        </div>
        <div class="row mt-4">
            <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                <label>
                    <span style="color : black">Client</span>
                </label>
                <div class="col-12" >
                    <div class=" text-right">
                        <b-form-group label-for="">
                        <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" 
                        :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" 
                        label="fullCompanyName"  v-model="filterSelectedCustomerByService">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                        </b-form-group>
                    </div>
                </div>
            </b-form-group>

        </div>
         <div  class="row mt-2">
            <div class="col-12 col-lg-6 pr-lg-2 ">
            <b-form-group   label-for="">
                <label>
                    <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong> Réclamation</strong></span>
                </label>
                <b-form-datepicker
                v-model="filterStartCountByService"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-12 col-lg-6   pr-lg-2">
            <b-form-group   label-for="">
                <label>
                    <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}} <strong> Réclamation</strong></span>
                </label>
                <b-form-datepicker
                v-model="filterEndCountByService"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
        </div>


        <p v-if="isRowEmpty(this.dataCountByService) == true">Pas de données à afficher.</p>

        <HorizentalBarChart
            class="mt-0 pt-0 mt-md-5 pt-md-5 pt-lg-0  mt-lg-0"
            :labels.sync="labelsCountByService"
            :values="dataCountByService"
            title=""
            :use-colors="false"
            :color="chartColor"
        />
    
    </div>
</div>
</div>

<div class="col-md-6 col-12 pt-4 pt-md-0 d-md-flex">

    <div class="card w-100 "> 
        <div class="card-body ">

        <div class="row">
            <div class="col-12">
                <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark">
                    {{$t("reporting.supplier.tabClaimsState.cardTitle4")}}
                </h4>
            </div>
        </div>
        <div class="row mt-4">
            <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                <label>
                    <span style="color : black">Client</span>
                </label>
                <div class="col-12" >
                    <div class=" text-right">
                        <b-form-group label-for="">
                        <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" 
                        :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" 
                        label="fullCompanyName"  v-model="filterSelectedCustomerByType">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                        </b-form-group>
                    </div>
                </div>
            </b-form-group>
            <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                <label>
                    <span style="color : black">{{$t('lists.service.filter')}}</span>
                </label>
                <v-select class="style-vselect-big" style="font-size:1.2em;" 
                :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceByType" :searchable="false">
                <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                </v-select>
            </b-form-group>
        </div>
        <div  class="row mt-2">
            <div class="col-12 col-lg-6 pr-lg-2 ">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}}<strong> Réclamation</strong></span>
                    </label>
                    <b-form-datepicker
                    v-model="filterStartCountByType"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
                <div class="col-12 col-lg-6   pr-lg-2">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}}<strong> Réclamation</strong></span>
                    </label>
                    <b-form-datepicker
                    v-model="filterEndCountByType"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright                         
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
            </div>


                <p v-if="isRowEmpty(this.dataCountByType) == true">Pas de données à afficher.</p> 

                <HorizentalBarChart
                    :labels.sync="labelsCountByType"
                    :values="dataCountByType"
                    title=""
                    :use-colors="false"
                />

            </div>
        </div> 
</div>
</div>
<div class="col-12  pt-4 d-md-flex align-items-stretch">
    <div class=" col-12  w-100 d-md-flex"   >
        <div class="card w-100 ">
            <div class="card-body " style="position: relative;">
                <div class="row">
                    <div  class="col-8 col-md-10 col-lg-10 col-xl-11">
                        <h4 class="text-dark mb-1 ">{{$t("reporting.supplier.tabClaimsState.cardTitle5")}}</h4>
                        <span class="text-dark ">{{$t("reporting.supplier.tabClaimsState.subTitle4")}}</span>
                    </div>
                    <div  class="col-4 col-md-2 col-lg-2 col-xl-1 text-right pl-2">
                            <div class="input-group input-group-sm">
                                <select class="custom-select custom-select-sm" v-model="yearForLine" @change="getClaimsRateMonthly">
                                <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
                                </select>
                                <div class="input-group-append">
                                    <label class="input-group-text">{{$t('years.label')}}</label>
                                </div>
                            </div>    
                    </div>
                </div> 
                <div class="row mt-5 mb-5  ">
                        <b-form-group class="col-12 col-lg-6   pr-lg-2"  label-for="" >
                            <label>
                                <span style="color : black">Client</span>
                            </label>
                            <div class="col-12 " >
                                <div class=" text-right">
                                    <b-form-group label-for="">
                                    <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" 
                                    :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" 
                                    label="fullCompanyName"  v-model="filterSelectedCustomerRateMonthly">
                                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                    </v-select>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-form-group>
                        <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6  ">
                            <label>
                                <span style="color : black">{{$t('lists.service.filter')}}</span>
                            </label>
                            <v-select class="style-vselect-big" style="font-size:1.2em;" 
                            :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                            :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceRateMonthly" :searchable="false">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                            </v-select>
                        </b-form-group>
                        
                            
                </div>    
                 
                
                <apexchart 
                    height="400"
                    width="100%"
                    type="area"
                    :options="chartOptionsMonthly"
                    :series="seriesMonthly"
                    :key="chartKeyMonthly"

                    />
            </div>
        </div>
    </div>
    
</div>


<div class="col-12  pt-4 d-md-flex align-items-stretch">
    <div class="col-md-6 col-12  pt-4 pr-md-4 pt-md-0 d-md-flex">

        <div class="card w-100 ">
            <div class="card-body ">
                <div class="row">
                    <div class="col-12">
                        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark"> {{$t("reporting.supplier.tabClaimsState.cardTitle7")}} </h4>
                    </div>
                </div> 
                <div class="row mt-4">
                    <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                        <label>
                            <span style="color : black">Client</span>
                        </label>
                        <div class="col-12" >
                            <div class=" text-right">
                                <b-form-group label-for="">
                                <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="filterSelectedCustomerRateByValidity">
                                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                                </b-form-group>
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                        <label>
                            <span style="color : black">{{$t('lists.service.filter')}}</span>
                        </label>
                        <v-select class="style-vselect-big" style="font-size:1.2em;" 
                        :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                        :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceRateByValidity" :searchable="false">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                        </v-select>
                    </b-form-group>
                </div>
                <div  class="row mt-2">
                    <div class="col-12 col-lg-6 pr-lg-2 ">
                    <b-form-group   label-for="">
                        <label>
                            <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong>Réclamation</strong></span>
                        </label>
                        <b-form-datepicker
                        v-model="filterStartRateByValidity"
                        :locale="$t('datPicker.locale')"
                        :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                        dark
                        reset-button
                        close-button
                        :label-reset-button="$t('datPicker.label-reset-button')"
                        :label-close-button="$t('datPicker.label-close-button')"
                        dropright
                        hide-header
                        ></b-form-datepicker>
                    </b-form-group>
                    </div>
                    <div class="col-12 col-lg-6   pr-lg-2">
                    <b-form-group   label-for="">
                        <label>
                            <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}}<strong> Réclamation</strong></span>
                        </label>
                        <b-form-datepicker
                        v-model="filterEndRateByValidity"
                        :locale="$t('datPicker.locale')"
                        :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                        dark
                        reset-button
                        close-button
                        :label-reset-button="$t('datPicker.label-reset-button')"
                        :label-close-button="$t('datPicker.label-close-button')"
                        dropright                         
                        hide-header
                        ></b-form-datepicker>
                    </b-form-group>
                    </div>
                </div>
                <p v-if="isRowEmpty(this.dataRateByValidity) == true">Pas de données à afficher.</p> 

                <PieChart class=" mt-4 pr-md-2" 
                :height="350" :labels.sync="this.labelsRateByValidity" 
                :series.sync="this.dataRateByValidity"  :key="componentKeyRateByValidity"   />
            </div>
        </div>
    </div>
    <div class="col-md-6 col-12  w-100 pt-4 pt-md-0 d-md-flex"   >
        <div class="card w-100 ">
            <div class="card-body " style="position: relative;">
                <div class="row">
                    <div  class="col-6 col-md-8 col-lg-10 ">
                        <h4 class="text-dark mb-1 ">{{$t("reporting.supplier.tabClaimsState.cardTitle6")}}</h4>
                    </div>
                    <div  class="col-6 col-md-4 col-lg-2 ">
                            <div class="input-group input-group-sm">
                                <select class="custom-select custom-select-sm" v-model="yearForReopened" @change="getClaimsReopened">
                                <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
                                </select>
                                <div class="input-group-append">
                                    <label class="input-group-text">{{$t('years.label')}}</label>
                                </div>
                            </div>    
                    </div>
                </div> 
                <div class="row mt-5 mb-5  ">
                        <b-form-group class="col-12 col-lg-6   pr-lg-2"  label-for="" >
                            <label>
                                <span style="color : black">Client</span>
                            </label>
                            <div class="col-12 " >
                                <div class=" text-right">
                                    <b-form-group label-for="">
                                    <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" 
                                    :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" 
                                    label="fullCompanyName"  v-model="filterSelectedCustomerForReopened">
                                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                    </v-select>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-form-group>
                        <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6  ">
                            <label>
                                <span style="color : black">{{$t('lists.service.filter')}}</span>
                            </label>
                            <v-select class="style-vselect-big" style="font-size:1.2em;" 
                            :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                            :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceForReopened" :searchable="false">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                            </v-select>
                        </b-form-group>
                        
                            
                </div>
                <div v-if="monthsLabelsForReopened && monthsLabelsForReopened.length && seriesDataForReopened  && seriesDataForReopened.length" class="row  pt-3"></div>
                    <DynamicGroupedBarChart
                    :labels="monthsLabelsForReopened"
                    :seriesData="seriesDataForReopened"
                    :chartKey="chartKeyForReopened"
                    />
            </div>
        </div>
    </div>
</div>


<div class="col-12  pt-4 d-md-flex align-items-stretch">

    <div class="col-md-6 col-12 pr-md-4 d-md-flex">

    <div class="card w-100 "> 
        <div class="card-body ">
            <div class="row">
                <div class="col-12">
                    <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark"> {{$t("reporting.supplier.tabClaimsState.cardTitle10")}} </h4>
                </div> 
            </div>
            <div class="row mt-4">
                <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                    <label>
                        <span style="color : black">Client</span>
                    </label>
                    <div class="col-12" >
                        <div class=" text-right">
                            <b-form-group label-for="">
                            <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="filterSelectedCustomerRateByBlType">
                                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                            </v-select>
                            </b-form-group>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                    <label>
                        <span style="color : black">{{$t('lists.service.filter')}}</span>
                    </label>
                    <v-select class="style-vselect-big" style="font-size:1.2em;" 
                    :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                    :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceRateByBlType" :searchable="false">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                    </v-select>
                </b-form-group>
            </div>
            <div  class="row mt-2">
                <div class="col-12 col-lg-6 pr-lg-2 ">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong>BL</strong> </span>
                    </label>
                    <b-form-datepicker
                    v-model="filterStartRateByBlType"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
                <div class="col-12 col-lg-6   pr-lg-2">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}} <strong>BL</strong> </span>
                    </label>
                    <b-form-datepicker
                    v-model="filterEndRateByBlType"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright                         
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
            </div>
            <p v-if="isRowEmpty(this.dataRateByBlType) == true">Pas de données à afficher.</p>
            <BarChartPercentage :useColors="false" class=" mt-4 pr-md-2" :height="350" :labels.sync="this.labelsRateByBlType" :data.sync="this.dataRateByBlType"  :key="componentKeyRateByBlType" :requestedPercentages="true"  />
        </div>
    </div> 
    </div>
    <div class="col-md-6 col-12  pt-4 pt-md-0 d-md-flex">
        <div class="card w-100 ">
            <div class="card-body ">
                <div class="row">
                    <div class="col-12">
                        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark"> {{$t("reporting.supplier.tabClaimsState.cardTitle11")}} </h4>
                    </div>
                </div> 
                <div class="row mt-4">
                    <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                        <label>
                            <span style="color : black">Client</span>
                        </label>
                        <div class="col-12" >
                            <div class=" text-right">
                                <b-form-group label-for="">
                                <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="filterSelectedCustomerRateByBlDatePerWeekDay">
                                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                                </b-form-group>
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                        <label>
                            <span style="color : black">{{$t('lists.service.filter')}}</span>
                        </label>
                        <v-select class="style-vselect-big" style="font-size:1.2em;" 
                        :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                        :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceRateByBlDatePerWeekDay" :searchable="false">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                        </v-select>
                    </b-form-group>
                </div>
                <div  class="row mt-2">
                    <div class="col-12 col-lg-6 pr-lg-2 ">
                    <b-form-group   label-for="">
                        <label>
                            <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong>BL</strong> </span>
                        </label>
                        <b-form-datepicker
                        v-model="filterStartRateByBlDatePerWeekDay"
                        :locale="$t('datPicker.locale')"
                        :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                        dark
                        reset-button
                        close-button
                        :label-reset-button="$t('datPicker.label-reset-button')"
                        :label-close-button="$t('datPicker.label-close-button')"
                        dropright
                        hide-header
                        ></b-form-datepicker>
                    </b-form-group>
                    </div>
                    <div class="col-12 col-lg-6   pr-lg-2">
                    <b-form-group   label-for="">
                        <label>
                            <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}} <strong>BL</strong></span>
                        </label>
                        <b-form-datepicker
                        v-model="filterEndRateByBlDatePerWeekDay"
                        :locale="$t('datPicker.locale')"
                        :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                        dark
                        reset-button
                        close-button
                        :label-reset-button="$t('datPicker.label-reset-button')"
                        :label-close-button="$t('datPicker.label-close-button')"
                        dropright                         
                        hide-header
                        ></b-form-datepicker>
                    </b-form-group>
                    </div>
                </div>
                <p v-if="isRowEmpty(this.dataRateByBlDatePerWeekDay) == true">Pas de données à afficher.</p>
                <PieChart class=" mt-4 pr-md-2" 
                :height="350" :labels.sync="this.labelsRateByBlDatePerWeekDay" 
                :useColors="true"
                :series.sync="this.dataRateByBlDatePerWeekDay"  :key="componentKeyRateByBlDatePerWeekDay"   />
            </div>
        </div>
    </div>
</div>

<div class="col-12  pt-4 d-md-flex align-items-stretch">
    <div class="col-md-6 col-12 pr-md-4 d-md-flex">
        <div class="card w-100 ">
            <div class="card-body ">
                <div class="row">
                    <div class="col-12">
                        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark"> {{$t("reporting.supplier.tabClaimsState.cardTitle12")}} </h4>
                    </div>
                </div> 
                <div class="row mt-4">
                    <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                        <label>
                            <span style="color : black">Client</span>
                        </label>
                        <div class="col-12" >
                            <div class=" text-right">
                                <b-form-group label-for="">
                                <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="filterSelectedCustomerRateByBlDatePerHour">
                                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                                </b-form-group>
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                        <label>
                            <span style="color : black">{{$t('lists.service.filter')}}</span>
                        </label>
                        <v-select class="style-vselect-big" style="font-size:1.2em;" 
                        :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                        :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceRateByBlDatePerHour" :searchable="false">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                        </v-select>
                    </b-form-group>
                </div>
                <div  class="row mt-2">
                    <div class="col-12 col-lg-6 pr-lg-2 ">
                    <b-form-group   label-for="">
                        <label>
                            <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong>BL</strong> </span>
                        </label>
                        <b-form-datepicker
                        v-model="filterStartRateByBlDatePerHour"
                        :locale="$t('datPicker.locale')"
                        :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                        dark
                        reset-button
                        close-button
                        :label-reset-button="$t('datPicker.label-reset-button')"
                        :label-close-button="$t('datPicker.label-close-button')"
                        dropright
                        hide-header
                        ></b-form-datepicker>
                    </b-form-group>
                    </div>
                    <div class="col-12 col-lg-6   pr-lg-2">
                    <b-form-group   label-for="">
                        <label>
                            <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}} <strong>BL</strong> </span>
                        </label>
                        <b-form-datepicker
                        v-model="filterEndRateByBlDatePerHour"
                        :locale="$t('datPicker.locale')"
                        :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                        dark
                        reset-button
                        close-button
                        :label-reset-button="$t('datPicker.label-reset-button')"
                        :label-close-button="$t('datPicker.label-close-button')"
                        dropright                         
                        hide-header
                        ></b-form-datepicker>
                    </b-form-group>
                    </div>
                </div>
                <p v-if="isRowEmpty(this.dataRateByBlDatePerHour) == true">Pas de données à afficher.</p>
                <BarChartPercentage 
                :useColors="false" class=" mt-4 pr-md-2" 
                :height="350" :labels.sync="this.labelsRateByBlDatePerHour" 
                :data.sync="this.dataRateByBlDatePerHour"  :key="componentKeyRateByBlDatePerHour" 
                :requestedPercentages="true" 
                :showLabelsOnTop="true" />

            </div>
        </div>
    </div>

    <div class="col-md-6 col-12 pt-4 pt-md-0 d-md-flex">
        <div class="card w-100">
            <div class="card-body">

            <!-- Card Title -->
            <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark">
                {{$t("reporting.supplier.tabClaimsState.cardTitle13")}}
            </h4>

            <div class="row mt-4">
                <b-form-group class="col-12 col-lg-6  pr-lg-2 "  label-for="" >
                    <label>
                        <span style="color : black">Client</span>
                    </label>
                    <div class="col-12" >
                        <div class=" text-right">
                            <b-form-group label-for="">
                            <v-select class="style-vselect-filterSelectedCustomer" style="font-size:1.2em;" :options="filterCustomersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName"  v-model="filterSelectedCustomerClaimIdentification">
                                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                            </v-select>
                            </b-form-group>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group v-if="isClaimTypeEnabled"  label-for="" class="col-12 col-lg-6   pr-lg-2">
                    <label>
                        <span style="color : black">{{$t('lists.service.filter')}}</span>
                    </label>
                    <v-select class="style-vselect-big" style="font-size:1.2em;" 
                    :options="filterServicesList.map(service => ({ name: service.name, value: service.id }))"
                    :placeholder="$t('lists.service.label')" label="name" v-model="filterSelectedServiceClaimIdentification" :searchable="false">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                    </v-select>
                </b-form-group>
            </div>


            <div  class="row mt-2">
                <div class="col-12 col-lg-6 pr-lg-2 ">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.startDate.label-no-date-selected')}} <strong>BL</strong> </span>
                    </label>
                    <b-form-datepicker
                    v-model="filterStartClaimIdentification"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
                <div class="col-12 col-lg-6   pr-lg-2">
                <b-form-group   label-for="">
                    <label>
                        <span style="color : black">{{$t('datPicker.endDate.label-no-date-selected')}} <strong>BL</strong></span>
                    </label>
                    <b-form-datepicker
                    v-model="filterEndClaimIdentification"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright                         
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
            </div>

            <PieChart
                class="mt-4 pr-md-2"
                :height="350"
                :labels="['Identifiées', 'Non identifiées']"
                :series="[identifiedPercentage, unidentifiedPercentage]"
                :useColors="true"
                :key="componentKeyClaimIdentificationStats"
            />



            </div>
        </div>
    </div>

</div>

</div>

</div>
</template>